import ReactDOM from 'react-dom';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ModalContent from 'Modals/ModalComponent/ModalContent';
export default class Modal extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const output = /*#__PURE__*/React.createElement(Fragment, null, props.open === true ? /*#__PURE__*/React.createElement(ModalContent, props, props.children) : undefined);
    return ReactDOM.createPortal(output, document.body);
  }
}
Modal.propTypes = {
  open: PropTypes.bool.isRequired
};
